import { createEvent } from 'ics';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import userIcon from '../../assets/image/DefaultAvatar.svg';
import { cloudfront_base_url } from "../../config/config";
import path from "../../routes/path";
import Button from "../button/Button";
import ModalBootstrap from "../modalBootstrap/ModalBootstrap";
import ShareButton from "../ShareButton/ShareButton";
import calendar from './img/calendar.svg';
import clock from './img/clock.svg';
import InfoIcon from './img/info-circle.svg';
import liveImg from './img/live.svg';
import quizIcon from './img/quiz.svg';
import './LiveSessionCard.scss';

const LiveSessionCard = (props) => {
    const { t } = useTranslation();
    const [infoToggle,setInfoToggle] = useState(false)
    const details = props.data;
    const timestamp = details?.start_time;
    const formattedDate = moment.unix(timestamp).format('DD-MMM-YY');
    const srartTimestamp = details?.start_time;
    const formattedStartTime = moment.unix(srartTimestamp).format('hh:mm A');
    const endTimestamp = details?.end_time;
    const formattedEndTime = moment.unix(endTimestamp).format('hh:mm A');


    const start_dt = moment.unix(timestamp)
    const start_tm = moment.unix(srartTimestamp)
    // const event_duration = moment.duration(moment.unix(props.event.to_timestamp).diff(moment.unix(props.event.from_timestamp)))
    console.log({ days: start_dt.days(), hours: start_tm.hours(), minutes: start_tm.minutes() })
    const event = {
        start: [start_dt.year(), start_dt.month() + 1, start_dt.date(), start_tm.hours(), start_tm.minutes()],
        duration: { hours: 1 },
        title: details?.meeting_title,
        description: details?.description,
        location: 'Al Imaan Institute Session',
        url: `${window.location.origin}`,
        // geo: { lat: this.currentLat, lon: this.currentLng },
        categories: ['Al Imaan Institute Session'],
        status: 'CONFIRMED',
        busyStatus: 'BUSY',
        // organizer: { name: this.meetingDetails.created_by.name, email: this.meetingDetails.created_by.email },
        alarms: [{
            action: 'audio',
            description: 'Reminder',
            trigger: { hours: 0, minutes: 30, before: true },
            repeat: 2,
            attachType: 'VALUE=URI',
            attach: 'Glass'
        }]
    }

    const addEventToIcsCalendar = async () => {
        const filename = `${details?.meeting_title}.ics`
        const file = await new Promise((resolve, reject) => {
            createEvent(event, (error, value) => {
                if (error) {
                    toast.warning('Location permission needed!')
                    reject(error)
                }
                resolve(new File([value], filename, { type: 'plain/text' }))
            }
            )
        })
        const url = URL.createObjectURL(file);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    }

    const addEventToCalendar = (googleCalendar) => {
        const startTimeGoogle = moment.unix(timestamp).format('YYYYMMDD')+'T'+moment.unix(srartTimestamp).subtract(5, 'minutes').format('HHmm')
        const endTimeGoogle = moment.unix(timestamp).format('YYYYMMDD')+'T'+moment.unix(srartTimestamp).add(1, "hours").subtract(5, 'minutes').format('HHmm')
        const startTimeOutlook = moment.unix(timestamp).format('YYYY-MM-DD')+'T'+moment.unix(srartTimestamp).format('HH:mm')
        const endTimeOutlook = moment.unix(timestamp).format('YYYY-MM-DD')+'T'+moment.unix(srartTimestamp).add(1, "hours").format('HH:mm')
        const startDateTime = encodeURIComponent(googleCalendar ? startTimeGoogle : startTimeOutlook)
        const endDateTime = encodeURIComponent(googleCalendar ? endTimeGoogle : endTimeOutlook)

        const url = googleCalendar ?
            `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${details?.meeting_title}&details=${details?.description}&location=${'Al Imaan Institute Session'}&dates=${startDateTime}%2F${endDateTime}&crm=AVAILABLE&reminders=email:10` :
            `https://outlook.live.com/calendar/0/action/compose?rru=addevent&subject=${details?.meeting_title}&startdt=${startDateTime}&enddt=${endDateTime}&location=${'Al Imaan Institute Session'}&body=${details?.description}&reminder=30`;
        window.open(url, "_blank");
    }

    return(
        <>
            <div className={"live-session-card-item"}>
                <div className="thumbnail">
                    <img className={"thum"} src={cloudfront_base_url+details?.thumbnail} alt={details?.title}/>
                    {details?.meeting_status==='running' &&
                        <div className="live-icon">
                            <img src={liveImg} alt="live"/>
                        </div>
                    }
                    {/* {props?.edit &&
                    <div className="edit-drop-down">
                        <div className="edit-drop-down-full">
                            <span className="bi bi-three-dots-vertical" />
                            <ul>
                                <li><Link>Public</Link></li>
                                <li><Link>Edit</Link></li>
                                <li><Link>Share</Link></li>
                                <li><Link>Delete</Link></li>
                            </ul>
                        </div>
                    </div>
                    } */}
                </div>
                <div className="content">
                    <div className="top">
                        <div className="date">
                            <img onClick={()=>setInfoToggle(!infoToggle)} src={InfoIcon} />
                            <span>{formattedDate}</span>
                        </div>
                        <div className="course-share">
                            <ShareButton link={`${window.origin}${process.env.PUBLIC_URL}${path.public_session_details}?id=${details?.session_id}`} />
                        </div>
                    </div>
                    <h3  onClick={()=>setInfoToggle(!infoToggle)} className="title" title={details?.title}><a>{details?.title}</a></h3>
                    <p className="time">{formattedStartTime} {!details?.start_time===null? `- ${formattedEndTime}`:''}</p>
                    <Button
                        onclickCallback={props?.cardModal?(e)=>setInfoToggle(true):(e)=>{props.onActionBtnClick(e,details)}}
                        btnText={props.actionBtnText}
                    />
                </div>
            </div>

            <ModalBootstrap
                show={infoToggle}
                handleClose={setInfoToggle}
                title="Session Info"
                size={"lg session-modal"}
            >
                <div className={`info-full-content `}>
                    <div className="info-header">
                        <div className="img">
                            <img src={details.user_data?.profile_picture?cloudfront_base_url+details.user_data.profile_picture:userIcon} alt={details.user_data?.name}/>
                        </div>
                        <div className="cont">
                            <h4><Link to={'/'}>{details.user_data?.name}</Link></h4>
                            <span>{details.user_data?.profile_title}</span>
                        </div>
                    </div>
                    <div className="bottom-content">
                        <div className="time-area">
                            <span><img src={calendar} /> {formattedDate}</span>
                            <span><img src={clock} /> {formattedStartTime}</span>
                            {details?.no_of_questions?
                            <span className={"quiz"}><img src={quizIcon} /> Number of Quiz: <b>{details?.no_of_questions}</b></span>
                            :''}
                        </div>
                        <div className="clanedar-btn">
                        <span>Add Event to:</span>
                        <Button
                                type="button"
                                onclickCallback={() => addEventToCalendar(true)}
                                btnText={t('content_page.google')}
                                btnClassName="google-btn"
                            />
                            <Button
                                type="button"
                                onclickCallback={() => addEventToCalendar(false)}
                                btnText={t('content_page.outlook')}
                                btnClassName="outlook-btn"
                            />
                            <Button
                                type="button"
                                onclickCallback={addEventToIcsCalendar}
                                btnText={t('content_page.iso')}
                            />
                        </div>
                        <h4 className="title">{details?.meeting_title}</h4>
                        <p dangerouslySetInnerHTML={{__html: details?.description}}>
                        </p>
                    </div>
                </div>
            </ModalBootstrap>
        </>
    )
}
export default LiveSessionCard;